<template>
    <div class="block">
        <span style="display: none;">
        this is a hidden element with the sole scope of re-render
        the list of colored labels: {{count}}
        </span>
        <div class="tags is-centered">
            <span v-for="labelAndClass in labelsAndClasses" >
                <span
                    class="tag"
                    :class="labelAndClass.class || defaultClass">
                    {{ labelAndClass.name }}
                    <button 
                        class="delete is-small" 
                        @click="deleteClicked(labelAndClass)">
                    </button>
                </span>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    name: "LabelledPills",
    props: {
        "labels": Array,
        "defaultClass": {type: String, default: ''}, 
    },
    emits: ["deleteClicked"],
    computed: {
        count(){
            return this.labels.length
        },
        labelsAndClasses(){return this.fixItems(this.labels)},
    },
    methods: {
        deleteClicked(event){
            this.$emit('deleteClicked', event.name)
        },
        fixItems(items){
            return items.map((item) => {
                if (typeof item === 'object'){
                    return item
                } else {
                    return {name: item, class: this.defaultClass}
            }})
        },
    },
    watch: {
        labels(){this.fixItems(this.labels)},
    },
}
</script>

